import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MasterVariantPageRBAC = {
  pageID: 'f6196d17a15a4f734eba290af0a42c6a',
  elementID: {
    ButtonAddVariant: 'ad6a4e55862de8352187fca9356075f4',
    ButtonEditVariant: '9a7223275cdb2b326975566ce9562788',
  },
} as const

export const useRBACMasterVariantPage = createUseRBAC(MasterVariantPageRBAC.elementID)

export type UseRBACMasterVariantPageType = ReturnType<typeof useRBACMasterVariantPage>
